import React, { useCallback, useMemo, useState } from "react";
import styles from "../Dashboard.module.scss";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Suspense } from "react";
import Loader from "components/Loader";
import { withTranslation } from "react-i18next";
import OpenInIcon from "assets/images/open_in_new.svg";
import MyNotes from "./MyNotes";
import TransferredNotes from "./TransferredNotes";
import { getStorage, setStorage } from "utils";
import constants from "../../../../constants";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Tooltip } from "reactstrap";
import AddNoteDashboardModal from "./modals/AddNoteDashboardModal";
import Separator from "assets/images/Separator.svg";

const Notes = ({
  t,
  appliedOfficeFilters,
  appliedStaffFilters,
  isSchedulerOnly,
  isNotesAndReminderFeatureEnabled,
}) => {
  const cachedActiveTab = getStorage(constants.notes.cache.Noteslisting);
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(
    cachedActiveTab?.activeTab ? cachedActiveTab.activeTab : 1
  );
  const [tooltipEditOpen, setTooltipEditOpen] = useState(false);
  const [addNoteModal, setAddNoteModal] = useState(false);
  const [editNoteModal, setEditNoteModal] = useState(null);
  const [addedNoteLoading, SetAddedNoteLoading] = useState(true);
  const tabName = constants.notesTabStatus;

  const manageTab = (tab) => {
    setActiveTab(tab);
    setStorage(constants.notes.cache.Noteslisting, {
      activeTab: tab,
    });
  };

  const handleRedirect = (e) => {
    if (e.target.closest(".interactive-element")) {
      return;
    }
    history.push(constants.routes.notes);
    setStorage("isChatFromDashBoard", true);
  };
  const setEditValue = useCallback((data) => {
    setEditNoteModal(data);
    setAddNoteModal(true);
  }, []);
  return (
    <div
      className={`${styles.notes_tab_wrapper} + " " + ${styles.rounded_container}`}
    >
      <div className={styles.header_wrapper}>
        <Nav tabs className={styles["nav-tabs"]}>
          <NavItem className={styles["nav-items"]}>
            <NavLink
              className={
                activeTab === tabName.myNote
                  ? styles["active"]
                  : styles["not-active"]
              }
              onClick={() => manageTab(tabName.myNote)}
            >
              {t("notes.myNotes")}
            </NavLink>
          </NavItem>
          <NavItem className={styles["nav-items"]}>
            <NavLink
              className={
                activeTab === tabName.transfferedNote
                  ? styles["active"]
                  : styles["not-active"]
              }
              onClick={() => manageTab(tabName.transfferedNote)}
            >
              {t("notes.transferredNotes")}
            </NavLink>
          </NavItem>
        </Nav>
        {isNotesAndReminderFeatureEnabled && (
          <div className="d-flex gap-sm">
            <button
              className={styles["add-chat-button"]}
              onClick={() => {
                setAddNoteModal(true);
              }}
            >
              <img
                src={require("assets/images/plus-icon-outline.svg").default}
                alt="icon"
              />
            </button>
            <img src={Separator} alt="separator" />
            <div className={styles.padding_right} onClick={handleRedirect}>
              <img src={OpenInIcon} alt="open-icon" id="notes_tooltip" />
            </div>
            <Tooltip
              isOpen={tooltipEditOpen}
              placement="top"
              target="notes_tooltip"
              toggle={() => {
                setTooltipEditOpen(!tooltipEditOpen);
              }}
            >
              {t("dashBoard.gotoNotes")}
            </Tooltip>
          </div>
        )}
      </div>
      <TabContent
        activeTab={activeTab}
        className={styles.notes_tab_content}
        id="scrollableDiv"
      >
        <Suspense fallback={<Loader />}>
          <TabPane tabId={tabName.myNote} className="w-100">
            {activeTab === tabName.myNote && addedNoteLoading && (
              <MyNotes
                manageTab={manageTab}
                tabName={tabName}
                isArchive={false}
                appliedOfficeFilters={appliedOfficeFilters}
                appliedStaffFilters={appliedStaffFilters}
                handleRedirect={handleRedirect}
                isSchedulerOnly={isSchedulerOnly}
                setEditNoteModal={setEditValue}
              />
            )}
          </TabPane>
          <TabPane tabId={tabName.transfferedNote} className="w-100">
            {activeTab === tabName.transfferedNote && addedNoteLoading && (
              <TransferredNotes
                manageTab={manageTab}
                tabName={tabName}
                setEditNoteModal={setEditValue}
                isArchive={false}
                appliedOfficeFilters={appliedOfficeFilters}
                appliedStaffFilters={appliedStaffFilters}
                handleRedirect={handleRedirect}
                isSchedulerOnly={isSchedulerOnly}
              />
            )}
          </TabPane>
          {addNoteModal && (
            <AddNoteDashboardModal
              isModalOpen={addNoteModal}
              editNoteModal={editNoteModal}
              t={t}
              setIsModalOpen={(type) => {
                if (typeof type === "string") {
                  setActiveTab(
                    type === "self" ? tabName.myNote : tabName.transfferedNote
                  );
                  SetAddedNoteLoading(false);
                  setTimeout(() => {
                    SetAddedNoteLoading(true);
                  }, 100);
                }
                setAddNoteModal(false);
              }}
            />
          )}
        </Suspense>
      </TabContent>
    </div>
  );
};

export default withTranslation()(Notes);
